import Clipboard from "@stimulus-components/clipboard"
import Swal from "sweetalert2"

export default class extends Clipboard {
  connect() {
    super.connect()
  }

  // Function to override when to input is copied.
  copied() {
    //
    super.copied()
    Swal.fire(
      {
        icon: "success",
        title: `Business ${this.element.dataset.bizName}`,
        text: 'Link copied !!!, now, you can share that link to everyone',
        showConfirmButton: true,
        timer: 10000,
      }
    )
  }
}